import React, { useState, useEffect, useContext } from "react";
import "./sectionSummary.scss";
import SeccionTitle from "../../atoms/seccion-title/seccionTitle";
import Summary from "../../molecules/summary/summary";
import ArrowButton from "../../atoms/arrow-button/arrowButton";
import Loading from "../../atoms/loading/loading";
import { updateDate } from "../../../services/scheduling";
import { postAssignAppointment } from "../../../services/scheduling";
import GlobalContext from "../../../contexts/globalContext";
import { getLegalAspectsByVerticalId } from "../../../services/legalAspects.js";
import { putLegalAspects } from "../../../services/legalAspects.js";
import { openNotification } from "../../../utils/OpenNotification";
// import ContactModal from "../../molecules/contact-modal/contactModal";

interface SectionSummaryInterface {
  setpageActive: any;
  setnextPage: any;
  confirmationDate: any;
  selectSpecialist: any;
  repro?: boolean;
  repData?: any;
  COMPANYID: any;
  content: any;
  setResp: any;
  respuesta: any;
}

interface LegalAspectsInterface {
  id?: number;
  name?: string;
  description?: string;
}

const SectionSummary = (props: SectionSummaryInterface) => {
  const [activeCheck, setactiveCheck] = useState(false);
  const {
    setpageActive,
    setnextPage,
    confirmationDate,
    selectSpecialist,
    repro,
    repData,
    setResp,
  } = props;

  const [loading, setloading] = useState(false);
  const [legalAspects, setlegalAspects] = useState<LegalAspectsInterface>({});
  const contextValue = useContext(GlobalContext);

  const handleSchedule = async () => {
    putLegalAspectsInfo();
    if (activeCheck) {
      setloading(true);
      if (repro) {
        confirmationDate["meetingId"] = repData.meetingId;
        confirmationDate["oldDateTime"] = repData.startDate;
        try {
          const dataUpdate = await updateDate(
            repData.id,
            contextValue.userInfoContext.data?.userJwt,
            confirmationDate
          );
          if (dataUpdate.data.status === 200) {
            const datas = { datas: { data: { isSubscriptionFree: false } } };

            await setResp(datas);
            setloading(false);
            setpageActive(5);
            window.ga_debug = { trace: true };
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "ClicAgendarServicioResumenServicio ",
              category: "RedDeAmorSesionIniciada ",
              action: "AceptoExitoso",
            });
          } else {
            const datas = { datas: { data: { isSubscriptionFree: false } } };
            await setResp(datas);
            openNotification(
              "error",
              "Error!",
              "Error en el servidor vuelve a intentarlo"
            );
            setloading(false);
          }
        } catch (error) {
          setloading(false);
        }
      } else {
        try {
          const data = await postAssignAppointment(
            confirmationDate.customer,
            confirmationDate.dateTime,
            confirmationDate.resource,
            confirmationDate.service,
            contextValue.userInfoContext.data?.userJwt
          );
          if (data.data.status === 200) {
            await setResp(data);
            setloading(false);
            setpageActive(5);
            localStorage.setItem(
              "appointmentId",
              data?.data?.data?.transResponse?.body?.data?.id
            );
            localStorage.setItem("isEvent", "F");
          } else if (data.data.status === 400) {
            const datas = { datas: { data: { isSubscriptionFree: false } } };
            await setResp(datas);
            openNotification(
              "info",
              "Información",
              data?.data?.developerMessage
            );
            /*window.location.assign(
              `${window.location.origin}/red-de-amor/agenda-red-de-amor`
            );*/
            setloading(false);
          } else {
            const datas = { datas: { data: { isSubscriptionFree: false } } };
            setResp(datas);
            openNotification(
              "error",
              "Error!",
              "Error en el servidor vuelve a intentarlo"
            );
            setloading(false);
          }
        } catch (error) {
          setloading(false);
        }
      }
    }
  };

  const getLegalAspects = async () => {
    try {
      const aspects = await getLegalAspectsByVerticalId(1);
      setlegalAspects(aspects.data.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const putLegalAspectsInfo = async () => {
    const token = contextValue.userInfoContext.data?.userJwt;
    const body = {
      id: legalAspects.id,
      email: confirmationDate.customer.email,
    };
    try {
      await putLegalAspects(body, token);
    } catch (error) {
      console.log(error);
    }
  };

  /* adds line jumps to legal aspect as it came from the databse without any */

  const addLineJumps = (text) => {
    const regex = /\s+(?=\d[.])/g;
    return text.replace(regex, "\n");
  };
  const [isOpen, setIsOpen] = useState(true);
  useEffect(() => {
    //console.log(props.content);
    setnextPage("Confirmación cita");
    getLegalAspects();
  }, []);
  return (
    <>
      {/* <ContactModal
    isOpen={isOpen}
    setIsOpen={setIsOpen}
    /> */}
      <div className="o-section-summary">
        <div className="o-section-summary__content__left">
          <SeccionTitle
            title={props.content.tituloBanner}
            description={props.content.tituloDescripcion}
          />
          <Summary
            editSummary={true}
            dateAndTime={confirmationDate.dateTime}
            selectSpecialist={selectSpecialist}
            setpage={setpageActive}
          />
        </div>
        <div className="o-section-summary__content__right">
          <div className="o-section-summary__content__right__consent">
            <p className="o-section-summary__content__right__consent__title">
              Consentimiento informado
            </p>
            <div className="o-section-summary__content__right__consent__info">
              <p>{addLineJumps(legalAspects?.description || "")}</p>
            </div>
            <span className="separator" />
            <p className="o-section-summary__content__right__consent__infoemail">
              {JSON.parse(props.content.descripcion.raw)?.content[0].content[0]
                .value +
                JSON.parse(props.content.descripcion.raw).content[0].content[1]
                  .content[0].value}
            </p>
            <p className="o-section-summary__content__right__consent__email">
              {
                JSON.parse(props.content.descripcion.raw).content[1].content[0]
                  .value
              }
            </p>
            <div className="o-section-summary__content__right__consent__terms">
              {loading ? (
                <Loading />
              ) : (
                <>
                  <div className="o-section-summary__content__right__consent__terms__content">
                    <span
                      className={
                        "o-section-summary__content__right__consent__terms__content__check" +
                        (activeCheck
                          ? " o-section-summary__content__right__consent__terms__content__check--active"
                          : "")
                      }
                      onClick={() => setactiveCheck(!activeCheck)}
                    />
                    <p className="o-section-summary__content__right__consent__terms__content__text">
                      {props.content.tituloBoton}
                    </p>
                  </div>
                  <div
                    className={
                      "o-section-summary__content__right__consent__terms__btn" +
                      (activeCheck
                        ? " o-section-summary__content__right__consent__terms__btn--active"
                        : "") +
                      " gtmRedDeAmorSesionIniciadaAgendarServicioResumenAcepto"
                    }
                    onClick={handleSchedule}
                  >
                    ACEPTO
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="o-section-summary__footer">
        <ArrowButton
          text={"Fecha y Hora"}
          way={"left"}
          onAction={() => {
            setnextPage("Fecha y Hora");
            setpageActive(3);
          }}
        />
      </div>
    </>
  );
};

export default SectionSummary;
